import { styled } from 'styled-components'

import { UnstyledButton } from '@b-stock/fe-core/bstock-next/components'
import { Colors } from '@b-stock/fe-core/design-system'

export const GridScroll = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 1rem 1rem 2rem;
`

export const Grid = styled.div`
  display: grid;
  gap: 0.5rem;
  grid-template-columns: repeat(2, 1fr);

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media (min-width: 1100px) {
    grid-template-columns: repeat(4, 1fr);
  }
`

const GridOverlay = styled.div`
  inset: 0;
  position: absolute;
  transition: opacity 0.15s;
`

export const GridHoverOverlay = styled(GridOverlay)`
  background: rgba(0, 91, 159, 0.25);
  opacity: 0;
`

export const GridVideoOverlay = styled(GridOverlay)`
  align-items: center;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  justify-content: center;
`

export const GridCell = styled(UnstyledButton)`
  aspect-ratio: 4 / 3;
  background: ${Colors.Semantic.Neutral.dark_grey};
  border-radius: 0.25rem;
  overflow: hidden;
  position: relative;
  width: 100%;

  &:hover ${GridHoverOverlay} {
    opacity: 1;
  }
`
